export default __webpack_public_path__ + "static/media/potsPlanters.7b6ff695.jpg";